import React from "react";
import TaskStatistics from "Areas/SharedFeatures/taskStatistics";
import locale from "./taskStatistics.locale";
export default function SettingsTaskStatistics() {
    return React.createElement(TaskStatistics, { title: locale.TASK_STATISTICS_TITLE, className: "panel-body-padding" });
}
